const readMore = () => {
  const buttons = document.querySelectorAll(".js-read-more-button");
  if (buttons.length == 0) {
    return;
  }
  const containers = document.querySelectorAll(".js-read-more-container");
  buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
      containers.forEach((container, i) => {
        if (i != index) {
          container.classList.remove("active");
        }
      });
      buttons.forEach((btn) => {
        if (btn != button) {
          btn.querySelector("p").innerText = btn
            .querySelector("p")
            .getAttribute("data-open");
          btn.classList.remove("active");
        }
      });
      console.log(containers);
      containers[index].classList.toggle("active");
      if (containers[index].classList.contains("active")) {
        button.querySelector("p").innerText = button
          .querySelector("p")
          .getAttribute("data-close");
        button.classList.add("active");
      } else {
        button.querySelector("p").innerText = button
          .querySelector("p")
          .getAttribute("data-open");
        button.classList.remove("active");
      }
    });
  });

  const resize = () => {
    containers.forEach((container) => {
      const initP = container.querySelector("p");
      container.style.maxHeight = initP.getBoundingClientRect().height + "px";
    });
  };
  resize();

  window.addEventListener("resize", () => {
    resize();
  });
};

export default readMore;
